<template>
  <v-container fluid>
    <aade-book :invoices="invoices" :loading="loading" :own=true></aade-book>
  </v-container>
</template>

<script>

import AadeBook from '../../components/AadeBook.vue';

export default {
  components: {
    AadeBook
  },
  computed: {
      dateRangeText () {
        return this.filter_dates.join(' ~ ')
      },
  },
  data() {
    return {
      loading: true,
      invoices: [],
    }
  },
  async created() {
      try {
        const response = await this.$api.get('/aade/sales');
        console.log(response);
        this.invoices = response.data;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
  }
}
</script>
